import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { HttpEventType, HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-upload-form',
  templateUrl: './upload-form.component.html',
  styleUrls: ['./upload-form.component.css']
})
export class UploadFormComponent implements OnInit {
  public progress: number;
  public message: string;
  
  @Output() public onUploadFinished = new EventEmitter();

  images : string [];
  image_names : string [];
  constructor(private http: HttpClient) { }

  ngOnInit() {
   // this.images = new Array<string>();
  }
// single file upload
  public uploadFiles = (files) => {
    if (files.length == 0) {
      return;
    }

    let fileToUpload = <File>files[0];
    this.uploadFile(fileToUpload)
  }

  uploadFile(file)
  {
    const formData = new FormData();
    formData.append('file', file, file.name);

    this.http.post(window.location.origin + '/api' + '/FileUpload/UploadImage', formData, {reportProgress: true, observe: 'events'})
      .subscribe(event => {
        if (event.type == HttpEventType.UploadProgress)
          this.progress = Math.round(100 * event.loaded / event.total);
        else if (event.type == HttpEventType.Response) {
          console.log("HttpEventType.Response")
          this.message = 'Upload success.';
          this.onUploadFinished.emit(event.body);
        }
        else{
          console.log("else : " + event.type);
        }
      }); 
  }

  onPaste(event: any) {
    const items = (event.clipboardData || event.originalEvent.clipboardData).items;
    let blob = null;

    for (const item of items) {
      if (item.type.indexOf('image') === 0) {
        console.log("onPaste")
        blob = item.getAsFile();
        this.uploadFile(blob)
      }
    }
/*
    // load image if there is a pasted image
    if (blob !== null) {
      const reader = new FileReader();
      reader.onload = (evt: any) => {
       // console.log(evt.target.result); // data url!
        //this.imgRenderer.nativeElement.src = evt.target.result;
      };
      reader.readAsDataURL(blob);
      this.uploadFile(blob)
    }*/
  }
/*
  public uploadData(data)
  {
    const formData = new FormData();
    formData.append('data', data, "notitle");
    console.log("uploadData");
    //var base_url = "https://localhost:44346"
   // console.log(base_url + '/api' + '/FileUpload/UploadImageData');
    
    this.http.post(window.location.origin + '/api' + '/FileUpload/UploadImageData', 
    formData, {reportProgress: true, observe: 'events'})
      .subscribe(event => {
        if (event.type == HttpEventType.UploadProgress)
          this.progress = Math.round(100 * event.loaded / event.total);
        else if (event.type == HttpEventType.Response) {
          console.log("HttpEventType.Response")
          this.message = 'Upload success.';
          this.onUploadFinished.emit(event.body);

        //  var imgelink = window.location.origin + '/upload/' + fileToUpload.name;
        // var imgelink = window.location.origin + '/upload/' + event.body.newFileName;

         // if(!this.images) this.images = new Array<string>();

        //  this.images.push(imgelink);
        }
        else{
          console.log("else : " + event.type);
        }
      });
  }
  */
// multiple file upload
/*
  public uploadFile = (files) => {
    if (files.length == 0) {
      return;
    }
    let filesToUpload : File[] = files;
    const formData = new FormData();
      
    Array.from(filesToUpload).map((file, index) => {
      
       

      return formData.append('file'+index, file, file.name);
    });

    
    this.http.post(window.location.origin + '/api' + '/FileUpload/UploadImage', formData, {reportProgress: true, observe: 'events'})
      .subscribe(event => {
        if (event.type == HttpEventType.UploadProgress)
        {
          console.log("HttpEventType.UploadProgress");
          this.progress = Math.round(100 * event.loaded / event.total);
        }
        else if (event.type == HttpEventType.Response) {
          console.log("HttpEventType.Response");
          this.message = 'Upload success.';
          this.onUploadFinished.emit(event.body);

          //this.images.push(window.location.origin + '/upload/' +  file.name);
        }
        else{
          console.log("else");
        }
      });
  }*/
}

